/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

// Shared layouts
import { Dashboard as DashboardLayout } from 'layouts';

import {
  Portlet,
  PortletHeader,
  PortletLabel,
  PortletContent,
} from 'components';

import { showAllMeters } from 'js/actions/meterActions';
import { showAllGroups } from 'js/actions/groupActions';
import { showAllCharge } from 'js/actions/chargeActions';

// Material components
import {
  Button,
  Grid2,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography,
  Box,
  IconButton,
  OutlinedInput,
  InputAdornment,
} from '@mui/material';

import { makeStyles } from '@mui/styles';

import * as action from 'js/actions/userActions';
import { showRoles } from 'js/actions/roleActions';

// Component styles
import styles from './styles';
import { useIntl } from 'react-intl';
import { DataGrid } from '@mui/x-data-grid';
import { Delete, Visibility, VisibilityOff } from '@mui/icons-material';
import { EmptyTable } from 'components/EmptyTable';
import Swal from 'sweetalert2';
const useStyles = makeStyles(styles);

const defaultValues = {
  role: null,
  meter: null,
  group: null,
  charge: null,
};

export default function FormUserMetimur() {
  const intl = useIntl();
  const classes = useStyles();
  const { setValue, getValues, handleSubmit, register } = useForm({
    defaultValues,
  });
  const dispatch = useDispatch();

  const roles = useSelector((state) => state.roles.roles);
  const meters = useSelector((state) => state.meters.meters);
  const corporatives = useSelector((state) => state.corporatives.corporatives);
  const groups = useSelector((state) => state.groups.groups);
  const charges = useSelector((state) => state.charges.charges);
  const [showPassword, setShowPassword] = useState(false);

  const [role, setRole] = useState(null);
  const [corporative, setCorporative] = useState(false);
  const [meter, setMeter] = useState({
    meter_id: '0',
    meter: 'Todas las Mediciones',
  });
  const [group, setGroup] = useState({
    group_id: '0',
    group: 'Todas las Mediciones',
  });
  const [charge, setCharge] = useState({
    charge_id: '0',
    charge: 'Todas las Mediciones',
  });

  useEffect(() => {
    dispatch(showRoles());
  }, []);

  const handleChange = (event) => {
    setRole(event.target.value);
  };

  const handleChangeCorporative = (event) => {
    setCorporative(event.target.value);
    dispatch(showAllMeters(event.target.value.id));
  };

  const handleChangeMeter = (event) => {
    setMeter(event.target.value);
    dispatch(showAllGroups(corporative.id, event.target.value.id));
  };

  const handleChangeGroup = (event) => {
    setGroup(event.target.value);
    dispatch(showAllCharge(event.target.value.id));
  };

  const handleChangeCharge = (event) => {
    setCharge(event.target.value);
  };

  const metimur_user = true;

  const validatePassword = (password) => {
    const errors = [];

    if (password.length < 8 || password.length > 16) {
      errors.push('Debe tener entre 8 y 16 caracteres.');
    }
    if (!/[a-z]/.test(password)) {
      errors.push('Debe contener al menos una letra minúscula.');
    }
    if (!/[A-Z]/.test(password)) {
      errors.push('Debe contener al menos una letra mayúscula.');
    }
    if (!/[@$!%*#?&+\-_]/.test(password)) {
      errors.push('Debe contener al menos un símbolo especial (@$!%*#?&+-_).');
    }

    return errors;
  };

  const onSubmit = (user) => {
    const passwordErrors = validatePassword(user.password);

    if (passwordErrors.length > 0) {
      Swal.fire({
        icon: 'error',
        title: 'Error en la contraseña',
        html: passwordErrors.join('<br>'), // Muestra los errores en líneas separadas
        confirmButtonText: 'Entendido',
      });
      return;
    }

    // Si la contraseña es válida, ejecuta el dispatch
    dispatch(action.signUp(user, corporative, state.data, metimur_user));
  };

  const handleDelete = (id) => {
    setState((prevState) => ({
      ...prevState,
      data: prevState.data.filter((item) => item.id !== id),
    }));
  };

  const [state, setState] = useState({
    data: [],
    columns: [
      {
        headerName: intl.formatMessage({
          id: 'app.metusers.addUser.gridCharges.corpCol',
        }),
        field: 'corporative',
        flex: 1,
        filterable: false,
        sortable: false,
      },
      {
        headerName: intl.formatMessage({
          id: 'app.metusers.addUser.gridCharges.meterCol',
        }),
        field: 'meter',
        flex: 1,
        filterable: false,
        sortable: false,
      },
      {
        headerName: intl.formatMessage({
          id: 'app.metusers.addUser.gridCharges.groupCol',
        }),
        field: 'group',
        flex: 1,
        filterable: false,
        sortable: false,
      },
      {
        headerName: intl.formatMessage({
          id: 'app.metusers.addUser.gridCharges.chargeCol',
        }),
        field: 'charge',
        flex: 1,
        filterable: false,
        sortable: false,
      },
      {
        headerName: 'Action',
        field: 'action',
        renderCell: (params) => {
          return (
            <IconButton onClick={() => handleDelete(params.row.id)}>
              <Delete />
            </IconButton>
          );
        },
      },
    ],
  });

  const setTable = () => {
    let obj = {
      corporative_id: corporative.id,
      corporative: corporative.name,
      meter_id: meter.id,
      meter: meter.name,
      group_id: group.id,
      group: group.name,
      charge_id: charge.id,
      charge: charge.name,
      id: Math.random().toString(36).substring(7),
    };

    setState({
      ...state,
      data: [...state.data, obj],
    });
    setCorporative(null);
    setMeter(null);
    setGroup({ group_id: '0', group: 'Todas las Mediciones' });
    setCharge({ charge_id: '0', charge: 'Todas las Mediciones' });
  };

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return (
    <DashboardLayout title="Creacion de Usuarios">
      <div className={classes.root}>
        <Portlet>
          <PortletHeader>
            <PortletLabel title="Nuevo Usuario" />
          </PortletHeader>
          <PortletContent noPadding>
            <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
              <Grid2 container={true} spacing={4}>
                <Grid2 size={{ lg: 6, md: 6 }}>
                  <div className={classes.fields}>
                    <TextField
                      className={classes.textField}
                      {...register('firstname')}
                      label={intl.formatMessage({
                        id: 'app.metusers.addUser.firstNameLbl',
                      })}
                      name="firstname"
                      required
                      variant="outlined"
                    />
                    <TextField
                      className={classes.textField}
                      {...register('lastname')}
                      label={intl.formatMessage({
                        id: 'app.metusers.addUser.lastNameLbl',
                      })}
                      name="lastname"
                      required
                      variant="outlined"
                    />
                    <TextField
                      className={classes.textField}
                      {...register('email')}
                      label={intl.formatMessage({
                        id: 'app.metusers.addUser.emailLbl',
                      })}
                      name="email"
                      type="email"
                      helperText={
                        !emailRegex.test(getValues('email')) &&
                        'Email inválido, ej: exemplo@exemplo.com ó exemplousuario@gmail.com, etc.'
                      }
                      required
                      //onChange={this.handleChange}
                      //value={email}
                      variant="outlined"
                    />
                    <FormControl className={classes.textField}>
                      <InputLabel id="demo-simple-select-label">
                        Password
                      </InputLabel>
                      <OutlinedInput
                        {...register('password')}
                        label={intl.formatMessage({
                          id: 'app.metusers.addUser.passwordLbl',
                        })}
                        name="password"
                        helperText={intl.formatMessage({
                          id: 'app.metusers.addUser.passwordRules',
                        })}
                        type={showPassword ? 'text' : 'password'}
                        variant="outlined"
                        required
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={() => setShowPassword(!showPassword)}
                              edge="end"
                            >
                              {showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  </div>
                </Grid2>
                <Grid2 size={{ lg: 6, md: 6 }}>
                  <div className={classes.fields}>
                    <TextField
                      className={classes.textField}
                      {...register('tel')}
                      label={intl.formatMessage({
                        id: 'app.metusers.addUser.phoneNumbLbl',
                      })}
                      name="tel"
                      required
                      variant="outlined"
                    />
                    <TextField
                      className={classes.textField}
                      {...register('cel')}
                      label={intl.formatMessage({
                        id: 'app.metusers.addUser.cellPhoneNumb',
                      })}
                      name="cel"
                      required
                      variant="outlined"
                    />
                    <FormControl className={classes.textField} required>
                      <InputLabel id="demo-simple-select-label">
                        {intl.formatMessage({
                          id: 'app.metusers.addUser.roleSel',
                        })}
                      </InputLabel>
                      <Select
                        {...register('role')}
                        labelId="demo-simple-select-disabled-label"
                        name="role"
                        onChange={handleChange}
                        label="Role"
                        value={role}
                      >
                        <MenuItem value="">
                          <em>
                            {intl.formatMessage({
                              id: 'app.metusers.addUser.roleSelMsg',
                            })}
                          </em>
                        </MenuItem>
                        {roles.map((role) => (
                          <MenuItem value={role.id} key={role.id}>
                            {role.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {/*  */}
                  </div>
                </Grid2>
              </Grid2>

              <form
                //className={classes.form}
                //onSubmit={setTable}
                style={{ marginBottom: '10px', marginTop: '20px' }}
              >
                <Typography
                  //className={classes.title}
                  variant="h4"
                >
                  {intl.formatMessage({ id: 'app.metusers.addUser.addToList' })}
                </Typography>

                <Grid2 container spacing={2} mt={2}>
                  <Grid2 size={{ lg: 3, md: 12 }}>
                    <FormControl className={classes.textField} required>
                      <InputLabel id="demo-simple-select-label">
                        {intl.formatMessage({
                          id: 'app.metusers.addUser.corpSel',
                        })}
                      </InputLabel>
                      <Select
                        {...register('corporative')}
                        labelId="demo-simple-select-disabled-label"
                        name="corporative"
                        label="Corporative"
                        onChange={handleChangeCorporative}
                        value={corporative}
                      >
                        <MenuItem value="">
                          <em>
                            {intl.formatMessage({
                              id: 'app.metusers.addUser.corpSelMsg',
                            })}
                          </em>
                        </MenuItem>
                        {corporatives.map((corporative) => (
                          <MenuItem value={corporative} key={corporative.id}>
                            {corporative.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid2>
                  <Grid2 size={{ lg: 3, md: 12 }}>
                    <FormControl className={classes.textField} required>
                      <InputLabel id="demo-simple-select-label">
                        {intl.formatMessage({
                          id: 'app.metusers.addUser.meterSel',
                        })}
                      </InputLabel>
                      <Select
                        {...register('meter')}
                        labelId="demo-simple-select-disabled-label"
                        name="meter"
                        onChange={handleChangeMeter}
                        value={meter}
                        disabled={!corporative}
                        label="Medidor"
                      >
                        <MenuItem value="">
                          <em>
                            {intl.formatMessage({
                              id: 'app.metusers.addUser.meterSelMsg',
                            })}
                          </em>
                        </MenuItem>
                        {meters.map((meter) => (
                          <MenuItem value={meter} key={meter.id}>
                            {meter.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid2>
                  <Grid2 size={{ lg: 3, md: 12 }}>
                    <FormControl className={classes.textField} required>
                      <InputLabel id="demo-simple-select-label">
                        {intl.formatMessage({
                          id: 'app.metusers.addUser.groupSel',
                        })}
                      </InputLabel>
                      <Select
                        {...register('group')}
                        labelId="demo-simple-select-disabled-label"
                        name="group"
                        label="Group"
                        disabled={!meter}
                        onChange={handleChangeGroup}
                        value={group}
                      >
                        <MenuItem value="">
                          <em>
                            {intl.formatMessage({
                              id: 'app.metusers.addUser.groupSelMsg',
                            })}
                          </em>
                        </MenuItem>
                        {groups.map((group) => (
                          <MenuItem value={group} key={group.id}>
                            {group.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid2>
                  <Grid2 size={{ lg: 3, md: 12 }}>
                    <FormControl className={classes.textField} required>
                      <InputLabel id="demo-simple-select-label">
                        {intl.formatMessage({
                          id: 'app.metusers.addUser.chargeSel',
                        })}
                      </InputLabel>
                      <Select
                        {...register('charge')}
                        labelId="demo-simple-select-disabled-label"
                        name="charge"
                        label="Charge"
                        disabled={!group}
                        onChange={handleChangeCharge}
                        value={charge}
                      >
                        <MenuItem value="">
                          <em>
                            {intl.formatMessage({
                              id: 'app.metusers.addUser.chargeSelMsg',
                            })}
                          </em>
                        </MenuItem>
                        {charges.map((charge) => (
                          <MenuItem value={charge} key={charge.id}>
                            {charge.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid2>
                  <Grid2 size={12}>
                    <Button
                      className={classes.signUpButton}
                      color="secondary"
                      onClick={setTable}
                      //type="submit"
                      size="large"
                      variant="outlined"
                    >
                      {intl.formatMessage({
                        id: 'app.metusers.addUser.addToListBtn',
                      })}
                    </Button>
                  </Grid2>
                </Grid2>
              </form>
              <Box sx={{ height: 450, width: '100%' }}>
                <DataGrid
                  rows={state.data}
                  columns={state.columns}
                  pageSize={5}
                  rowsPerPageOptions={[5]}
                  disableSelectionOnClick
                  getRowId={(row) => row.id}
                  slots={{
                    noRowsOverlay: () => (
                      <EmptyTable text="Datos sin Ingresar" />
                    ),
                  }}
                  sx={{
                    paddingBottom: '1rem',
                    borderRadius: '0.5rem',
                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                    backgroundColor: 'background.paper', // Color de fondo de la tabla
                    border: '1px solid #ccc',
                    borderColor: '#ccc',
                    '& .MuiDataGrid-root': {
                      border: 'none', // Eliminar borde de la tabla
                    },
                    '& .MuiDataGrid-cell': {
                      borderBottom: '1px solid rgba(224, 224, 224, 1)', // Borde inferior de la celda
                      maxHeight: '60px', // Altura máxima de la celda
                    },
                    '& .MuiDataGrid-columnHeaders': {
                      borderBottom: '1px solid rgb(199, 199, 199)', // Borde inferior del encabezado de columna
                    },
                    '& .MuiDataGrid-row': {
                      borderBottom: '1px solid rgb(199, 199, 199)', // Borde inferior de la fila
                      maxHeight: '60px', // Altura máxima de la fila
                    },
                  }}
                />
              </Box>
              <Button
                className={classes.signUpButton}
                color="secondary"
                size="large"
                type="submit"
                variant="contained"
                sx={{ marginTop: '20px' }}
              >
                {intl.formatMessage({ id: 'app.metusers.addUser.registerBtn' })}
              </Button>
            </form>
          </PortletContent>
        </Portlet>
      </div>
    </DashboardLayout>
  );
}
